export default __webpack_public_path__ + "static/media/T_DarkBlue.079a84c7.png";